var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 26,
    viewBox: "0 0 8 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99822 6.58139C5.53947 6.58139 6.78891 5.33195 6.78891 3.7907C6.78891 2.24944 5.53947 1 3.99822 1C2.45696 1 1.20752 2.24944 1.20752 3.7907C1.20752 5.33195 2.45696 6.58139 3.99822 6.58139Z",
    fill: "#262626",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99831 15.5116C5.53957 15.5116 6.789 14.2621 6.789 12.7209C6.789 11.1796 5.53957 9.93018 3.99831 9.93018C2.45705 9.93018 1.20761 11.1796 1.20761 12.7209C1.20761 14.2621 2.45705 15.5116 3.99831 15.5116Z",
    fill: "#262626",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99831 25.0001C5.53957 25.0001 6.789 23.7507 6.789 22.2094C6.789 20.6681 5.53957 19.4187 3.99831 19.4187C2.45705 19.4187 1.20761 20.6681 1.20761 22.2094C1.20761 23.7507 2.45705 25.0001 3.99831 25.0001Z",
    fill: "#262626",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingBl);
export default __webpack_public_path__ + "static/media/setting_bl.faa558872b095c3c8f4f4a848f5e4036.svg";
export { ForwardRef as ReactComponent };